import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: theme.spacing(2, 4),
    fontSize: '1rem',
  },

  importerInput: {
    display: 'none',
  },
}));

export default useStyles;
